export const INVOICES_STATUS = [
    { label: 'Paid', value: 'paid' },
    { label: 'Due', value: 'due' },
    { label: 'Over Due', value: 'over_due' },
    { label: 'Match', value: 'match' },
    { label: 'Mismatch', value: 'mismatch' },
]